import { render, staticRenderFns } from "./FrmEditEventViewer.vue?vue&type=template&id=6c8ed776"
import script from "./FrmEditEventViewer.vue?vue&type=script&lang=js"
export * from "./FrmEditEventViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports